import React, {Component} from 'react'
import {UserNav, CurrentRanking, RankingIQ, BestRanking, QuizzRanking, ChartRanking} from './../../../components'
import {UserChallengeStyle} from './../../../styles'
import {connect} from 'react-redux'

export default class Challenge extends Component {

  render() {
    return (
      <div className={` user-challenge ${UserChallengeStyle}`}>
        <UserNav />
        <div className='flex user-challenge-ranking'>
          <div className="user-challenge-push">
            <RankingIQ />
          </div>
          <div className="user-challenge-push">
            <CurrentRanking />
          </div>
          <div className="user-challenge-push">
            <BestRanking />
          </div>
          <div className="user-challenge-push">
           <QuizzRanking />
          </div>
        </div>
        <div className='user-challenge-charts'>
          <ChartRanking />
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Challenge.js